import { Api } from "./api"

export class ActiveStatusApi extends Api {
  constructor() {
    super('active_statuses', ['active'])
  }
}
